module.exports = __webpack_public_path__ + "img/robot-img4.93a85797.png";